import { AppRoute } from 'common/enums/enums';
import { createBrowserHistory, History } from 'history';

class Navigation {
  #history: History;

  public constructor() {
    this.#history = createBrowserHistory();
  }

  public get history(): History {
    return this.#history;
  }

  public push(path: AppRoute | string): void {
    this.#history.push(path);
  }

  public goBack(): void {
    this.#history.back();
  }
}

export { Navigation };
